// extracted by mini-css-extract-plugin
module.exports = {"tooltipPercent":"MeterTypeGraph_tooltipPercent__3YLK7"};